import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { Timeline } from "./Timeline";
import { assertRange } from "./Debug";
/**
 * A Timeline State. Provides the methods: `setStateAtTime("state", time)` and `getValueAtTime(time)`
 * @param initial The initial state of the StateTimeline.  Defaults to `undefined`
 */
export var StateTimeline = /*#__PURE__*/function (_Timeline) {
  _inherits(StateTimeline, _Timeline);
  function StateTimeline() {
    var _this;
    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "stopped";
    _classCallCheck(this, StateTimeline);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(StateTimeline).call(this));
    _this.name = "StateTimeline";
    _this._initial = initial;
    _this.setStateAtTime(_this._initial, 0);
    return _this;
  }
  /**
   * Returns the scheduled state scheduled before or at
   * the given time.
   * @param  time  The time to query.
   * @return  The name of the state input in setStateAtTime.
   */
  _createClass(StateTimeline, [{
    key: "getValueAtTime",
    value: function getValueAtTime(time) {
      var event = this.get(time);
      if (event !== null) {
        return event.state;
      } else {
        return this._initial;
      }
    }
    /**
     * Add a state to the timeline.
     * @param  state The name of the state to set.
     * @param  time  The time to query.
     * @param options Any additional options that are needed in the timeline.
     */
  }, {
    key: "setStateAtTime",
    value: function setStateAtTime(state, time, options) {
      assertRange(time, 0);
      this.add(Object.assign({}, options, {
        state: state,
        time: time
      }));
      return this;
    }
    /**
     * Return the event before the time with the given state
     * @param  state The state to look for
     * @param  time  When to check before
     * @return  The event with the given state before the time
     */
  }, {
    key: "getLastState",
    value: function getLastState(state, time) {
      // time = this.toSeconds(time);
      var index = this._search(time);
      for (var i = index; i >= 0; i--) {
        var event = this._timeline[i];
        if (event.state === state) {
          return event;
        }
      }
    }
    /**
     * Return the event after the time with the given state
     * @param  state The state to look for
     * @param  time  When to check from
     * @return  The event with the given state after the time
     */
  }, {
    key: "getNextState",
    value: function getNextState(state, time) {
      // time = this.toSeconds(time);
      var index = this._search(time);
      if (index !== -1) {
        for (var i = index; i < this._timeline.length; i++) {
          var event = this._timeline[i];
          if (event.state === state) {
            return event;
          }
        }
      }
    }
  }]);
  return StateTimeline;
}(Timeline);